/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, React.createElement("path", {
  d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm-.04 13.7c.793 0 1.4.607 1.4 1.4 0 .793-.607 1.4-1.4 1.4-.793 0-1.4-.607-1.4-1.4 0-.793.607-1.4 1.4-1.4zm.343-9.7c2.141 0 3.695 1.442 3.695 3.428 0 1.688-1.062 2.524-1.917 3.194-.556.438-1.036.816-1.07 1.308a1.045 1.045 0 01-.584.78 1.399 1.399 0 01-.488.088 1.306 1.306 0 01-.68-.186.958.958 0 01-.445-.641l-.01-.108c0-1.249.89-1.955 1.677-2.578.694-.55 1.294-1.026 1.294-1.759 0-.652-.456-1.353-1.458-1.353-.7 0-1.309.415-1.515 1.033l-.036.129a1.2 1.2 0 01-.334.518c-.417.374-.956.301-1.04.288a1.032 1.032 0 01-.523-.227c-.392-.328-.372-.837-.368-.902l.002-.071C6.718 5.134 8.208 4 10.303 4z"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "Help";
Svg.element = element;
export default Svg;
